import produce from 'immer'

import { RootState } from 'types'
import { Action } from 'redux/actions'
import { InboxThreadActions } from 'redux/actions/inboxThreads'

export default function reduce(
  state: RootState['inboxThreads'] = {
    isLoading: false,
    unreadTodosCount: 0,
    unreadReviewsCount: 0,
  },
  action: Action,
): RootState['inboxThreads'] {
  switch (action.type) {
    case InboxThreadActions.UPDATE_UNREAD_INBOX_THREADS_COUNT: {
      const { unreadReviewsCount, unreadTodosCount } = action.payload

      return produce(state, (draftState) => {
        draftState.unreadReviewsCount = unreadReviewsCount
        draftState.unreadTodosCount = unreadTodosCount
      })
    }

    default:
      return state
  }
}
